<div class="responsive-user-menu">
    <!--<i (click)="toggleUserMenu()" class="large  material-icons">person</i>-->
    <div (click)="clickedOut($event)" class="menu-backdrop">
        <div class="responsive-menu-wrap">
        <div class="coverMask"></div>

        <div class="res-header">
            <i (click)="toggleUserMenu()" class="material-icons">arrow_forward</i>
            <!--<div class="avartar-wrap">
        <img class="avatar-logo" src="../../../assets/img/default-avatar.png" alt="Alternate Text" />
    </div>-->
            <!--<div (click)="toggleUserMenu()" class="avatar-logo avatar-logo" title="{{_Globals.getFullName()}}" style="background-color:#fff;color:#259bbf;border-radius:50%;width:37px;height:37px;border:1px solid #259bbf;position:relative;top:-4px;margin: 0 7px;">
                <span style="position:relative;top:9px;left:14px;font-weight: bolder;">{{_Globals.getFullName()[0]}}</span>
            </div>-->
            <div class="badge badge-white">{{_Globals.getFullName()[0]}}</div>

            <div class="avatar-name" title="{{fullName}}">
                <span>{{fullName}}</span>
            </div>

        </div>

        <div class="res-body">
            <div class="container-fluid">
                <ul>
                    <li *ngIf="_Globals.getAvailableModes().length > 1" class="selectMode">
                        <div class="">
                            <select id="customSelectId" #mode (change)="changeMode(mode.value)" class="btn-secondary dropdown-toggle modeSelector">
                                <option *ngFor="let mode of _Globals.getAvailableModes()" [selected]="_Globals.getMode() == mode" [value]="mode">{{mode}}</option>
                            </select>
                        </div>
                        <hr style="margin: 0 0 10px;" />
                    </li>
                    <li *ngIf="_Globals.getMode() == 'Coach'" (click)="toggleUserMenu()">
                        <a [routerLink]="['/app/profile']">
                            <i class="pe-7s-user"></i>
                            <span>Profile</span>
                        </a>
                    </li>
                    <li *ngIf="_Globals.getMode() == 'Client'" (click)="toggleUserMenu()">
                        <a [routerLink]="['/app/client_profile']">
                            <i class="pe-7s-user"></i>
                            <span>Profile</span>
                        </a>
                    </li>
                    <li>
                        <a (click)="logout()">
                            <i style="transform: rotate(90deg);" class="pe-7s-upload"></i>
                            <span>Logout</span>
                        </a>
                    </li>
                </ul>
                
                
            </div>

            <!--<div class="container-fluid logout">
                <button class="btn" (click)="logout()"></button>
            </div>-->
        </div>
    </div>
    </div>
</div>